(() => {
  const ready = (fn) => document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', fn, { once: true })
    : fn();

  ready(() => {
    const normaliseLegacyContent = (root) => {
      const citationPattern = /【[^】]*†L\d+(?:-L?\d+)?】/g;
      const unsafeParent = 'a, script, style, textarea, code, pre';

      const collectTextNodes = (scope) => {
        const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
        const nodes = [];
        while (walker.nextNode()) nodes.push(walker.currentNode);
        return nodes;
      };

      collectTextNodes(root).forEach((node) => {
        if (node.parentElement?.closest('script, style, textarea, code, pre')) return;
        node.nodeValue = node.nodeValue.replace(citationPattern, '');
      });

      root.querySelectorAll('[onclick]').forEach((element) => {
        element.removeAttribute('onclick');
      });

      root.querySelectorAll('img').forEach((image) => {
        if (!image.hasAttribute('loading')) image.setAttribute('loading', 'lazy');
        if (!image.hasAttribute('decoding')) image.setAttribute('decoding', 'async');
      });

      Array.from(root.querySelectorAll('p')).forEach((paragraph) => {
        const cleanText = paragraph.textContent.trim();
        const headingMatch = paragraph.childElementCount === 0
          ? cleanText.match(/^(#{1,3})\s+(.+)$/)
          : null;

        if (headingMatch) {
          const heading = document.createElement(headingMatch[1].length === 3 ? 'h3' : 'h2');
          heading.textContent = headingMatch[2];
          paragraph.replaceWith(heading);
          return;
        }

        if (!cleanText && !paragraph.querySelector('img, picture, video, iframe, svg, input, button')) {
          paragraph.remove();
        }
      });

      collectTextNodes(root).forEach((node) => {
        if (!node.nodeValue || node.parentElement?.closest(unsafeParent)) return;

        const source = node.nodeValue;
        const tokenPattern = /\[([^\]\n]+)\]\(((?:https:\/\/|\/(?!\/)|mailto:|tel:|#\S)[^)\s]+)\)|\*\*([^*\n]+)\*\*/g;
        let cursor = 0;
        let match;
        let changed = false;
        const fragment = document.createDocumentFragment();

        while ((match = tokenPattern.exec(source)) !== null) {
          changed = true;
          if (match.index > cursor) fragment.append(document.createTextNode(source.slice(cursor, match.index)));

          if (match[1] && match[2]) {
            const link = document.createElement('a');
            link.href = match[2];
            link.textContent = match[1];
            if (link.protocol === 'https:' && link.hostname !== window.location.hostname) {
              link.rel = 'noopener noreferrer';
            }
            fragment.append(link);
          } else {
            const strong = document.createElement('strong');
            strong.textContent = match[3];
            fragment.append(strong);
          }

          cursor = tokenPattern.lastIndex;
        }

        if (!changed) return;
        if (cursor < source.length) fragment.append(document.createTextNode(source.slice(cursor)));
        node.replaceWith(fragment);
      });
    };

    document.querySelectorAll('[data-sc-richtext]').forEach(normaliseLegacyContent);

    const toggle = document.querySelector('[data-sc-menu-toggle]');
    const nav = document.querySelector('[data-sc-nav]');

    if (toggle && nav) {
      const closeMenu = () => {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      };

      toggle.addEventListener('click', () => {
        const open = !nav.classList.contains('is-open');
        nav.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      });

      nav.addEventListener('click', (event) => {
        if (event.target.closest('a')) closeMenu();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeMenu();
      });

      document.addEventListener('click', (event) => {
        document.querySelectorAll('.sc-nav details[open]').forEach((details) => {
          if (!details.contains(event.target)) details.removeAttribute('open');
        });
      });
    }

    document.querySelectorAll('.js-sc-project-form').forEach((form) => {
      const steps = Array.from(form.querySelectorAll('[data-sc-form-step]'));
      const indicators = Array.from(form.querySelectorAll('[data-sc-progress-step]'));
      const nextButtons = Array.from(form.querySelectorAll('[data-sc-next]'));
      const backButtons = Array.from(form.querySelectorAll('[data-sc-back]'));
      const submitButton = form.querySelector('button[type="submit"]');
      const pendingKey = `sc-contact-pending:${window.location.pathname}:${form.id}`;
      const referenceKey = `sc-contact-reference:${window.location.pathname}:${form.id}`;
      const draftKey = `sc-contact-draft:${window.location.pathname}:${form.id}`;
      let current = 0;
      let hasStarted = false;
      let submitTimer;
      let draftTimer;

      const track = (event, details = {}) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event, ...details });
      };

      const ensureShopifyProtocol = () => {
        const ensureHidden = (name, value) => {
          let field = form.querySelector(`input[name="${name}"]`);
          if (!field) {
            field = document.createElement('input');
            field.type = 'hidden';
            field.name = name;
            form.prepend(field);
          }
          field.value = value;
          field.setAttribute('value', value);
        };

        ensureHidden('form_type', 'contact');
        ensureHidden('utf8', '✓');
        form.setAttribute('method', 'post');
      };

      const clearPending = () => {
        try {
          sessionStorage.removeItem(pendingKey);
        } catch (_) {}
      };

      const getPending = () => {
        try {
          return Number(sessionStorage.getItem(pendingKey) || 0);
        } catch (_) {
          return 0;
        }
      };

      const getStoredReference = () => {
        try {
          return sessionStorage.getItem(referenceKey) || '';
        } catch (_) {
          return '';
        }
      };

      const createReference = () => {
        const now = new Date();
        const stamp = [
          now.getFullYear(),
          String(now.getMonth() + 1).padStart(2, '0'),
          String(now.getDate()).padStart(2, '0')
        ].join('');
        const bytes = new Uint8Array(3);
        if (window.crypto?.getRandomValues) {
          window.crypto.getRandomValues(bytes);
        } else {
          bytes.forEach((_, index) => { bytes[index] = Math.floor(Math.random() * 256); });
        }
        const suffix = Array.from(bytes, (value) => value.toString(36).padStart(2, '0'))
          .join('')
          .slice(0, 6)
          .toUpperCase();
        return `SC-${stamp}-${suffix}`;
      };

      const ensureReference = () => {
        const existing = getStoredReference();
        if (existing) return existing;
        const reference = createReference();
        try {
          sessionStorage.setItem(referenceKey, reference);
        } catch (_) {}
        return reference;
      };

      const clearReference = () => {
        try {
          sessionStorage.removeItem(referenceKey);
        } catch (_) {}
      };

      const draftFields = () => Array.from(form.elements).filter((field) => (
        field.name &&
        field.id &&
        field.type !== 'hidden' &&
        field.type !== 'submit' &&
        field.type !== 'button' &&
        !field.disabled
      ));

      const saveDraft = () => {
        const fields = {};
        draftFields().forEach((field) => {
          fields[field.id] = {
            value: field.value,
            checked: Boolean(field.checked),
            selectable: field.type === 'checkbox' || field.type === 'radio'
          };
        });
        try {
          sessionStorage.setItem(draftKey, JSON.stringify({ savedAt: Date.now(), fields }));
        } catch (_) {}
      };

      const restoreDraft = () => {
        let draft;
        try {
          draft = JSON.parse(sessionStorage.getItem(draftKey) || 'null');
        } catch (_) {
          draft = null;
        }
        if (!draft?.fields || Date.now() - Number(draft.savedAt || 0) > 24 * 60 * 60 * 1000) {
          try {
            sessionStorage.removeItem(draftKey);
          } catch (_) {}
          return;
        }
        draftFields().forEach((field) => {
          const saved = draft.fields[field.id];
          if (!saved) return;
          if (saved.selectable) field.checked = Boolean(saved.checked);
          else field.value = saved.value ?? '';
        });
      };

      const clearDraft = () => {
        window.clearTimeout(draftTimer);
        try {
          sessionStorage.removeItem(draftKey);
        } catch (_) {}
      };

      const scheduleDraftSave = () => {
        window.clearTimeout(draftTimer);
        draftTimer = window.setTimeout(saveDraft, 250);
      };

      const renderReference = (reference) => {
        if (!reference) return;
        const success = form.querySelector('.sc-form-success');
        if (!success) return;
        let note = success.querySelector('[data-sc-enquiry-reference]');
        if (!note) {
          note = document.createElement('p');
          note.dataset.scEnquiryReference = '';
          success.append(note);
        }
        note.hidden = false;
        note.textContent = `Reference: ${reference}`;
      };

      const showFailure = (message) => {
        let notice = form.querySelector('[data-sc-submit-failure]');
        if (!notice) {
          notice = document.createElement('div');
          notice.className = 'sc-form-errors';
          notice.dataset.scSubmitFailure = '';
          notice.setAttribute('role', 'alert');
          notice.tabIndex = -1;
          form.prepend(notice);
        }
        notice.innerHTML = `<strong>Your enquiry was not confirmed.</strong><p>${message}</p><p>You can also email <a href="mailto:info@sachetsco.com?subject=Packing%20project%20enquiry%20-%20website%20form%20fallback">info@sachetsco.com</a> or call <a href="tel:+61294124604">02 9412 4604</a>.</p><button class="sc-button sc-button--outline" type="button" data-sc-retry-form>Retry form</button>`;
        notice.querySelector('[data-sc-retry-form]')?.addEventListener('click', () => {
          notice.remove();
          clearPending();
          setSubmitting(false);
          ensureShopifyProtocol();
          if (steps.length) setStep(0);
          form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, { once: true });
        notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
        notice.focus?.({ preventScroll: true });
      };

      const showClientSuccess = (reference = '') => {
        if (form.querySelector('.sc-form-success')) {
          renderReference(reference);
          return;
        }
        const success = document.createElement('div');
        success.className = 'sc-form-success';
        success.setAttribute('role', 'status');
        success.tabIndex = -1;
        success.innerHTML = '<strong>Thank you. Your packing brief has been received.</strong><p data-sc-enquiry-reference hidden></p><p>We will review it and contact you with suitability questions or the recommended next step.</p>';
        form.replaceChildren(success);
        renderReference(reference);
        success.focus({ preventScroll: true });
      };

      const setSubmitting = (submitting) => {
        if (!submitButton) return;
        if (!submitButton.dataset.scOriginalLabel) {
          submitButton.dataset.scOriginalLabel = submitButton.textContent.trim();
        }
        submitButton.disabled = submitting;
        submitButton.setAttribute('aria-busy', String(submitting));
        submitButton.textContent = submitting
          ? 'Submitting securely…'
          : submitButton.dataset.scOriginalLabel;
      };

      ensureShopifyProtocol();

      const params = new URLSearchParams(window.location.search);
      const confirmed = params.get('contact_posted') === 'true' || Boolean(form.querySelector('.sc-form-success'));
      const serverErrors = Boolean(form.querySelector('.sc-form-errors:not([data-sc-submit-failure])'));
      const pendingAt = getPending();
      const confirmedReference = getStoredReference();

      if (!confirmed) restoreDraft();

      if (confirmed || serverErrors) {
        clearPending();
        if (confirmed) {
          showClientSuccess(confirmedReference);
          renderReference(confirmedReference);
          clearReference();
          clearDraft();
        }
      } else if (pendingAt && Date.now() - pendingAt < 5 * 60 * 1000) {
        clearPending();
        showFailure('Shopify returned to the form without a success confirmation, so please review the fields and submit once more. Do not assume the enquiry was sent until the green confirmation appears.');
      }

      form.addEventListener('focusin', () => {
        if (hasStarted) return;
        hasStarted = true;
        track('start_project_brief', { page_path: window.location.pathname });
      });
      form.addEventListener('input', scheduleDraftSave);
      form.addEventListener('change', scheduleDraftSave);

      const setStep = (index, { moveFocus = true, scroll = true } = {}) => {
        current = Math.max(0, Math.min(index, steps.length - 1));
        steps.forEach((step, position) => {
          step.hidden = position !== current;
          step.setAttribute('aria-hidden', String(position !== current));
        });
        indicators.forEach((indicator, position) => {
          indicator.classList.toggle('is-active', position === current);
          if (position === current) {
            indicator.setAttribute('aria-current', 'step');
          } else {
            indicator.removeAttribute('aria-current');
          }
          indicator.setAttribute('aria-pressed', String(position === current));
        });
        if (moveFocus) steps[current]?.querySelector('legend')?.focus?.({ preventScroll: true });
        if (scroll) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      const validCurrentStep = () => {
        const required = Array.from(steps[current].querySelectorAll('[required]'));
        const firstInvalid = required.find((field) => !field.checkValidity());
        if (firstInvalid) {
          firstInvalid.reportValidity();
          firstInvalid.focus();
          return false;
        }
        return true;
      };

      nextButtons.forEach((button) => button.addEventListener('click', () => {
        if (validCurrentStep()) {
          track('project_brief_step', { step_number: current + 1, step_action: 'complete' });
          setStep(current + 1);
        }
      }));
      backButtons.forEach((button) => button.addEventListener('click', () => setStep(current - 1)));
      indicators.forEach((indicator, position) => indicator.addEventListener('click', () => {
        if (position === current) return;
        if (position < current) {
          setStep(position);
          return;
        }
        if (validCurrentStep()) {
          track('project_brief_step', { step_number: current + 1, step_action: 'complete' });
          setStep(position);
        }
      }));

      const landing = form.querySelector('[name="contact[Landing page]"]');
      const referrer = form.querySelector('[name="contact[Referring page]"]');
      const requestedOption = form.querySelector('[name="contact[Requested option]"]');
      const requestedFormat = form.querySelector('[name="contact[Requested artwork format]"]');
      if (landing) landing.value = window.location.href;
      if (referrer) referrer.value = document.referrer || 'Direct';
      if (requestedOption) requestedOption.value = params.get('interest') || '';
      if (requestedFormat) requestedFormat.value = params.get('format') || '';
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'].forEach((key) => {
        const field = form.querySelector(`[name="contact[${key}]"]`);
        if (field) field.value = params.get(key) || '';
      });

      const calculatePriority = () => {
        let score = 0;
        const status = form.querySelector('[name="contact[Product readiness]"]:checked')?.value || '';
        const frequency = form.querySelector('[name="contact[Expected order frequency]"]')?.value || '';
        const volume = form.querySelector('[name="contact[First run quantity]"]')?.value || '';
        const primaryFormat = form.querySelector('[name="contact[Primary packaging format]"]')?.value || '';
        const formats = Math.max(
          form.querySelectorAll('.js-sc-format-choice:checked').length,
          /multiple formats/i.test(primaryFormat) ? 2 : 0
        );
        const documents = form.querySelector('[name="contact[Documents available]"]')?.value || '';
        const timeline = form.querySelector('[name="contact[Target timing]"]')?.value || '';

        if (/monthly|2-3 months|quarterly/i.test(frequency)) score += 30;
        else if (/twice yearly|annually/i.test(frequency)) score += 15;
        if (formats >= 2) score += 20;
        if (/20,000|50,000|100,000|commercial bulk/i.test(volume)) score += 20;
        else if (/5,000|10,000/i.test(volume)) score += 12;
        if (/finished.*ready/i.test(status)) score += 12;
        if (/specification|coa|allergen|inci|sds/i.test(documents)) score += 8;
        if (!/urgent|under 4 weeks/i.test(timeline)) score += 10;

        const priority = score >= 75 ? 'P1 - priority recurring or multi-format lead'
          : score >= 50 ? 'P2 - production enquiry'
          : 'P3 - paid trial or readiness review';
        const priorityField = form.querySelector('[name="contact[Lead priority]"]');
        if (priorityField) priorityField.value = `${priority} (${score}/100)`;
        track('submit_project_brief', { lead_priority: priority.split(' - ')[0], lead_score: score });
      };

      form.addEventListener('submit', () => {
        ensureShopifyProtocol();
        calculatePriority();
        saveDraft();
        const reference = ensureReference();
        const referenceField = form.querySelector('[name="contact[Enquiry reference]"]');
        const submittedAtField = form.querySelector('[name="contact[Submitted at]"]');
        if (referenceField) referenceField.value = reference;
        if (submittedAtField) submittedAtField.value = new Date().toISOString();
        try {
          sessionStorage.setItem(pendingKey, String(Date.now()));
        } catch (_) {}
        setSubmitting(true);
        window.clearTimeout(submitTimer);
        submitTimer = window.setTimeout(() => {
          if (!document.contains(form)) return;
          setSubmitting(false);
          showFailure('The page did not receive a Shopify success response. Complete any human-verification prompt, then try again once.');
        }, 120000);
      });

      if (steps.length && !confirmed && !serverErrors) {
        setStep(0, { moveFocus: false, scroll: false });
      }
    });
  });
})();
